import React, { Component } from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Spinner } from '../Spiner/Spiner';
import { SearchWorkoutsActionCreators } from '../../../Store/ActionCreators/SearchWorkoutsActionCreators';

class InfiniteWorkoutsScroll extends Component {
    loadMoreWorkouts = (filter, offsetId) => {
        this.props.getMoreWorkouts(filter, offsetId);
    };

    render() {
        const { offsetId, workouts, scrollableTarget, children, filter } = this.props;

        return (
            <InfiniteScroll
                dataLength={workouts.length}
                next={() => this.loadMoreWorkouts(filter, offsetId)}
                hasMore={true}
                loader={<Spinner />}
                scrollableTarget={scrollableTarget}
            >
                {children}
            </InfiniteScroll>
        );
    }
}

InfiniteWorkoutsScroll.defaultProps = {
    filter: '',
};

const mapStateToProps = ({ workoutSearch: { workouts, offsetId } }) => ({
    workouts,
    offsetId,
});

const mapDispatchToProps = dispatch => ({
    getMoreWorkouts: (filter, offsetId) => dispatch(SearchWorkoutsActionCreators.getMoreWorkout(filter, offsetId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(InfiniteWorkoutsScroll);



// WEBPACK FOOTER //
// ./src/UI/Components/InfiniteScroll/InfiniteWorkoutsScroll.js